module.exports = new __parcel__URL__("google_logo.9ec994e6.png").toString();